"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";

const PINK_THEME_USER_IDS = new Set([
    "72363cb6-b07f-486e-a43e-076e07c5cc79",
    "cf8287ad-9510-4d7a-8e09-9be48f8ccac6",
    "731b76bd-1ec3-4848-be26-743990755c77",
]);

export function PinkThemeBody() {
    const { data: session } = useSession();
    const userId = session?.user?.id;
    const isPinkTheme = userId != null && PINK_THEME_USER_IDS.has(userId);

    useEffect(() => {
        document.body.classList.toggle("newui-pink-theme", isPinkTheme);
        return () => document.body.classList.remove("newui-pink-theme");
    }, [isPinkTheme]);

    return null;
}
